export default {
  "hero.eyebrow": "CENTRUM ZASOBÓW ARKUSZA USFANS",
  "hero.title": "Arkusz USFans — znajdź produkty, linki i mądrzejsze przewodniki zakupowe",
  "hero.description": "Poznaj arkusz USFans, odkryj przydatne linki do produktów, porównaj kategorie, zrozum kontrolę jakości i wysyłkę oraz podejmuj lepsze decyzje zakupowe dzięki naszemu niezależnemu centrum zasobów.",
  "hero.trust": "Niezależne źródło • Aktualizowane przewodniki • Wsparcie wielojęzyczne",
  "hero.buyNow": "Kup teraz",
  "hero.explore": "Poznaj arkusz USFans",

  "dropdown.label": "Wybierz kategorię",
  "dropdown.placeholder": "Wybierz kategorię, aby przejść do głównej witryny",

  "categories.title": "Poznaj kategorie arkusza USFans",
  "categories.description": "Wybierz kategorię poniżej, aby otworzyć odpowiadającą jej sekcję na głównej witrynie. Każdy przycisk prowadzi prosto do produktów, które chcesz przeglądać.",

  "about.title": "Czym jest arkusz USFans?",
  "about.p1": "Arkusz USFans to uporządkowane narzędzie do odkrywania produktów. Zamiast otwierać dziesiątki kart, zbiera linki do produktów, kategorie, zdjęcia i notatki w jednym miejscu, dzięki czemu szybciej przeglądasz, porównujesz i przechodzisz dalej.",
  "about.p2": "Pomyśl o nim jak o jednej tabeli, w której każdy wiersz to jeden produkt, a każda kolumna zawiera przydatne szczegóły — kategorię, nazwę, link i dodatkowe notatki. Ponieważ wszystko jest pogrupowane według kategorii, możesz szybko przełączać się między butami, bluzami, koszulkami, kurtkami i akcesoriami.",
  "about.p3": "Dobry arkusz pomaga też przemyśleć zakup. Możesz sprawdzić zdjęcia z kontroli jakości, przejrzeć szczegóły wysyłki i porównać kilka opcji, zanim złożysz zamówienie.",
  "about.cta": "Dowiedz się, jak działa arkusz USFans",

  "guide.title": "Jak korzystać z arkusza",
  "guide.step1.title": "Wybierz kategorię",
  "guide.step1.desc": "Zacznij od sekcji, która pasuje do tego, czego szukasz, od butów po akcesoria.",
  "guide.step2.title": "Przeglądaj i porównuj",
  "guide.step2.desc": "Czytaj nazwy, linki i notatki, aby wybrać produkty odpowiadające Twoim potrzebom.",
  "guide.step3.title": "Sprawdź szczegóły",
  "guide.step3.desc": "Przejrzyj cenę, rozmiary, zdjęcia QC i wysyłkę, zanim podejmiesz decyzję.",
  "guide.step4.title": "Otwórz produkt",
  "guide.step4.desc": "Przejdź do głównej witryny, aby zobaczyć pełną ofertę i dokończyć zamówienie.",

  "cards.title": "Przewodniki i informacje USFans",
  "cards.description": "Niezależne, rzetelne przewodniki, które pomogą Ci zrozumieć arkusz, wysyłkę, kontrolę jakości i nie tylko.",
  "card.review.title": "Recenzja USFans",
  "card.review.desc": "Niezależny przegląd obejmujący zamawianie, magazyn, kontrolę jakości, wysyłkę i ogólne doświadczenia klientów.",
  "card.shipping.title": "Koszt wysyłki USFans",
  "card.shipping.desc": "Zrozum, jak waga, wymiary, kraj docelowy i metoda wysyłki wpływają na całkowity koszt.",
  "card.coupon.title": "Kupon USFans",
  "card.coupon.desc": "Dowiedz się, jak znajdować i weryfikować aktualne oferty kuponów przed ich użyciem.",
  "card.discount.title": "Kod rabatowy USFans",
  "card.discount.desc": "Poznaj warunki kodów rabatowych i sprawdź, czy oferta jest nadal ważna.",
  "card.warehouse.title": "Magazyn USFans",
  "card.warehouse.desc": "Dowiedz się o przechowywaniu, kontroli jakości, konsolidacji i przygotowaniu paczek przed wysyłką.",
  "card.legit.title": "Czy USFans jest legalny?",
  "card.legit.desc": "Sprawdź zaufanie, bezpieczeństwo, płatności, wysyłkę i czynniki związane ze sprzedawcą przed zamówieniem.",

  "articleCta.title": "Przeczytaj nasz przewodnik dla początkujących",
  "articleCta.desc": "Dopiero zaczynasz z arkuszem USFans? Zacznij od naszego oryginalnego, szczegółowego przewodnika o działaniu, kontroli jakości, kosztach wysyłki i bezpieczeństwie zakupów.",
  "articleCta.button": "Przeczytaj pełny przewodnik",

  "finalCta.title": "Gotowy, aby poznać arkusz USFans?",
  "finalCta.desc": "Zacznij od arkusza, porównaj istotne informacje i skorzystaj z naszych przewodników przed podjęciem decyzji.",
  "finalCta.button": "Poznaj arkusz USFans",

  "category.shoes": "Buty",
  "category.hoodies": "Bluzy / Swetry",
  "category.tshirts": "Koszulki",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie / Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Komplety",
  "category.underwear": "Bielizna / Majtki",
  "category.jersey": "Trykot",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne rzeczy",

  "pillars.title": "Przewodniki arkusza USFans",
  "pillars.desc": "Szczegółowe, niezależne przewodniki pomagające zrozumieć każdy aspekt doświadczenia z arkuszem USFans.",
  "pillar.spreadsheet.title": "Przewodnik po arkuszu",
  "pillar.spreadsheet.desc": "Czym jest arkusz USFans, jak działa i jak go używać krok po kroku.",
  "pillar.review.title": "Recenzja USFans",
  "pillar.review.desc": "Zamawianie, magazyn, QC, wysyłka i ogólne doświadczenie klienta.",
  "pillar.shipping.title": "Koszt wysyłki",
  "pillar.shipping.desc": "Jak waga, wymiary i wybór przewoźnika wpływają na koszt wysyłki.",
  "pillar.coupon.title": "Przewodnik kuponów",
  "pillar.coupon.desc": "Jak znajdować i weryfikować aktualne kupony USFans.",
  "pillar.discount.title": "Kod rabatowy",
  "pillar.discount.desc": "Ważność, warunki i jak stosować kody rabatowe USFans.",
  "pillar.warehouse.title": "Przewodnik magazynu",
  "pillar.warehouse.desc": "Przechowywanie, QC, konsolidacja i przygotowanie paczek.",
  "pillar.legit.title": "Czy USFans jest legalny?",
  "pillar.legit.desc": "Bezpieczeństwo, ochrona płatności i czynniki zaufania.",
  "pillar.qc.title": "Przewodnik QC",
  "pillar.qc.desc": "Jak czytać zdjęcia QC i co sprawdzać przed zatwierdzeniem.",
  "pillar.beginner.title": "Poradnik dla początkujących",
  "pillar.beginner.desc": "Pierwsze zamówienie USFans od rejestracji do dostawy.",
  "pillar.safety.title": "Przewodnik bezpieczeństwa",
  "pillar.safety.desc": "Podstawowe środki ochrony konta, płatności i prywatności.",

  "readMore": "Czytaj więcej",
};